import { render, staticRenderFns } from "./OhRule.vue?vue&type=template&id=00f93e69&scoped=true&"
import script from "./OhRule.vue?vue&type=script&lang=js&"
export * from "./OhRule.vue?vue&type=script&lang=js&"
import style0 from "./OhRule.vue?vue&type=style&index=0&id=00f93e69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f93e69",
  null
  
)

export default component.exports